import { render } from "./DetalleIncidencia.vue?vue&type=template&id=4e431f56"
import script from "./DetalleIncidencia.vue?vue&type=script&lang=js"
export * from "./DetalleIncidencia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__